module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-happy.54b51e1f.png";